import * as React from "react";
import useAppContextRole from "../../app-context/useAppContextRole";
import useListMoves from "../../hooks/moves/useListMoves";

import { Move, AppContextRole } from "../../types";
import Card from "../common/Card";

import Layout from "../common/Layout";
import List, { ListProps } from "../common/List";
import Button from "../common/PressableButton";
import Text from "../common/Text";
import CreateOrUpdateMove from "./CreateOrUpdateMove";

import MoveOne from "./MoveOne";

export interface MoveGridProps {
  moves?: Move[];
  emptyText?: string;
}

function MoveGrid({ moves, emptyText = "No videos" }: MoveGridProps) {
  const movesQuery = useListMoves({ enabled: !moves });

  const VideoList = React.useCallback(
    (props: Pick<ListProps, "renderEmpty" | "renderItem">) => {
      if (moves) {
        return (
          <List<Move> {...props} getKey={(item) => item.id} items={moves} />
        );
      }

      return <List.Async<Move> {...movesQuery} {...props} />;
    },
    [moves, movesQuery]
  );

  const [role] = useAppContextRole();

  return (
    <Layout.Grid fullWidth size={0.5}>
      <VideoList
        renderEmpty={() => (
          <Layout.Box greedy>
            <Text textAlign="center">{emptyText}</Text>
          </Layout.Box>
        )}
        renderItem={({ item }: { item: Move; index: number }) => (
          <Layout.Box size={0.5}>
            <Card>
              <CreateOrUpdateMove
                id={item.id}
                disabled={role === AppContextRole.Learner}
              >
                {({ onPress, disabled }) => (
                  <Button onPress={onPress} disabled={disabled}>
                    <Layout.Box size={1}>
                      <MoveOne move={item} />
                    </Layout.Box>
                  </Button>
                )}
              </CreateOrUpdateMove>
            </Card>
          </Layout.Box>
        )}
      />
    </Layout.Grid>
  );
}

export default MoveGrid;
